import script from "./SignupForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupForm.vue?vue&type=script&setup=true&lang=ts"

import "./SignupForm.vue?vue&type=style&index=0&id=332e082a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332e082a"]])

export default __exports__